import my from "../assets/mine.jpg";
import img3 from"../assets/sanjana..jpg";
import img2 from"../assets/sanjiv.jpeg";
import img4 from"../assets/snekha.jpg";
const Projectcarddata=[
    {
        imgsrc:img4,
        title:"Chief Executive Officer",
        view:"https://www.linkedin.com/in/snekhasuresh21/",
        text:"Snekha.S"

    },
    {
        imgsrc:my,
        title:"Chief Technical Officer",
        view:"https://www.linkedin.com/in/harshankumarhrk/",
        text:"Kishore Harshan Kumar.R",
        social:"https://linktr.ee/harshan_kumar"
    },
    
    {
        imgsrc:img3,
        title:"Chief Product Officer",
        view:"https://www.linkedin.com/in/sanjana-doss-2a3700224/",
        text:"Sanjana .M",
        social:"https://linktr.ee/Sanjanadoss"
    },
    {
        imgsrc:img2,
        title:"Chief Operations Officer",
        view:"https://www.linkedin.com/in/sanjiv-s-45b28a224/",
        text:"Sanjiv .S"

    },
    

];
export default Projectcarddata;